import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Card } from '@ygtechnologies/rubus-ui';
import React from 'react';
import theme from './FlatCard.module.scss';

export interface FlatCardProps {
    title?: React.ReactNode;
    /** Rendered on the right side of the header row (e.g. an Edit button). */
    actions?: React.ReactNode;
    loading?: boolean;
    className?: string;
    contentClassName?: string;
    /** Grid spans for dashboard grids (mirrors the old DashboardCard API). */
    colSpan?: number;
    rowSpan?: number;
    onClick?: () => void;
    children?: React.ReactNode | (() => React.ReactNode);
}

const joinClasses = (...classes: (string | undefined)[]) => classes.filter(Boolean).join(' ');

const spanClass = (prefix: 'colSpan' | 'rowSpan', span?: number) =>
    span && span > 1 ? theme[`${prefix}-${span}`] : undefined;

/**
 * MacGyver's dashboard/details card: rubus-ui flat Card + optional header row (title left,
 * actions right) + loading state. Replaces the component-library DashboardDataCard.
 */
export const FlatCard: React.FC<FlatCardProps> = ({
    title,
    actions,
    loading,
    className,
    contentClassName,
    colSpan,
    rowSpan,
    onClick,
    children,
}) => {
    return (
        <Card
            variant="flat"
            onClick={onClick}
            className={joinClasses(theme.card, spanClass('colSpan', colSpan), spanClass('rowSpan', rowSpan), className)}>
            {(title || actions) && (
                <div className={theme.header}>
                    {title && <h4>{title}</h4>}
                    {actions && <div className={theme.actions}>{actions}</div>}
                </div>
            )}
            <div className={joinClasses(theme.content, contentClassName)}>
                {loading ? <LoadingIndicator /> : typeof children === 'function' ? children() : children}
            </div>
        </Card>
    );
};
